import { Tabs, TabsProps } from '@mui/material';

export const DialogTabs: React.FC<TabsProps> = ({ slotProps, children, ...props }) => {
  const indicatorSlotProps = typeof slotProps?.indicator === 'function' ? undefined : slotProps?.indicator;

  return (
    <Tabs
      {...props}
      slotProps={{
        ...slotProps,
        indicator: {
          ...indicatorSlotProps,
          sx: {
            height: '3px',
            ...(indicatorSlotProps && 'sx' in indicatorSlotProps ? indicatorSlotProps.sx : {}),
          },
        },
      }}
    >
      {children}
    </Tabs>
  );
};
